var React = require('react');
import { checkUserRegister, signup, checkUser } from '../actions/LoginServiceCreator';

import Facebook from './Facebook';
var cookie = require('react-cookie');

class Login extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  render() {
    return (
      <div>
        <div className="container_fluid main_container second-section login-container" id="content">
          <div className="row-fluid clearfix login-innercontainer">
            <div className="logged-container">
              <div className="signup-content">
                <div className="login-types">
                  <div className="login-title">
                    Sign up
                  </div>
                  <div className="social-signup">
                    <form method="post" className="signup-form" name="signup-form">
                      <div className="signup-title">
                        <span>Title:</span>
                        <select name="title" className="formTitle">
                          <option value="select">select</option>
                          <option value="male">Mr.</option>
                          <option value="female">Miss</option>
                        </select>
                        <div id="title-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>First name:</span>
                        <input type="text" required pattern="\w+" width="100" name="fName" className="formFname" />
                        <div id="firstname-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Last name:</span>
                        <input type="text" required pattern="\w+" width="100" name="lName" className="formLname" />
                        <div id="lastname-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Username:</span>
                        <input type="text" required pattern="\w+" width="100" name="username" className="formUname" onBlur={ this.checkusername.bind(this) } />
                        <div id="user-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Email:</span>
                        <input type="email" required pattern="/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/" width="100" name="email" className="formEmail"
                        />
                        <div id="email-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Password:</span>
                        <input type="password" required pattern="(?=.*\d)(?=.*[a-z]).{6,}" onchange="signup-form.confirm.pattern = this.value;" width="100"
                          name="password" className="formPwd" />
                        <div id="pass-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <span>Confirm Password:</span>
                        <input type="password" required pattern="(?=.*\d)(?=.*[a-z]).{6,}" width="100" name="confirm" className="formCnfPwd"
                        />
                        <div id="confirmpass-err" className="signup-error"></div>
                      </div>
                      <div className="signup-title">
                        <a href="/"><span className="cancel-btn">Cancel</span></a>
                        <div className="complete" onClick={ this.submit.bind(this) }><span className="complete-tick">✔</span><span className="complete-btn">complete</span></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
  validatelogin(response) {
    response.sessionid = cookie.load('sid');
    response.ip = cookie.load('ip');
    response.is_fb_login = 0;
    response.is_gmail_login = 1;
    response.is_twitter_login = 0;
    response.is_linkedin_login = 0;
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(signup, response);
  }
  checkusername() {
    var username = $(".formUname").val();
    var param = {
      folink_username: username
    };
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(checkUser, param);
  }
  submit() {
    var title = $(".formTitle").val();
    var first_name = $(".formFname").val();
    var last_name = $(".formLname").val();
    var folink_username = $(".formUname").val();
    var email = $(".formEmail").val();
    var password = $(".formPwd").val();
    var confirm = $(".formCnfPwd").val();
    var re = "";

    if (title == "select") {
      $('#title-err').text("select appropriate title");
      $(".formTitle").focus();
      return false;
    } else {
      $('#title-err').text("");
    }
    //  re = /[^a-zA-Z0-9]/;
    if (first_name == "") {
      $('#firstname-err').text("Error: First name cannot be blank!");
      $(".formFname").focus();
      return false;
    } else {
      $('#firstname-err').text("");
    }
    // re = /[^a-zA-Z0-9]/;
    if (last_name == "") {
      $('#lastname-err').text("Error: Last name cannot be blank!");
      $(".formLname").focus();
      return false;
    } else {
      $('#lastname-err').text("");
    }
    re = /[^a-zA-Z0-9]/;
    if (folink_username == "") {
      $('#user-err').text("Error: Username cannot be blank!");
      $(".formUname").focus();
      return false;
    } else {
      $('#user-err').text("");
    }
    re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    if (email == "") {
      $('#email-err').text("Error: email cannot be blank!");
      $(".formEmail").focus();
      return false;
    } else if (!re.test(email)) {
      $('#email-err').text("Error: enter valid email id");
      $(".formEmail").focus();
      return false;
    } else {
      $('#email-err').text("");
    }
    // re = re =(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/);
    if (password == "") {
      $('#pass-err').text("Error: password cannot be blank!");
      $(".formPwd").focus();
      return false;
    } else if (password != "") {
      if (password.length < 6) {
        $('#pass-err').text("Error: Password must contain at least six characters!");
        $(".formPwd").focus();
        return false;
      } else {
        $('#pass-err').text("");
      }
    }
    if (confirm == "") {
      $('#confirmpass-err').text("Error: confirm password cannot be blank!");
      $(".formPwd").focus();
      return false;
    } else if (password != "" && password != confirm) {
      $('#confirmpass-err').text("Error: Please check that you've entered and confirmed your password!");
      $(".formPwd").focus();
      return false;
    } else {
      $('#confirmpass-err').text("");
    }
    var gender = title;
    var formValues = {
      gender,
      first_name,
      last_name,
      email,
      password,
      folink_username
    };
    this.validatelogin(formValues);
    //window.location = "/";
    return;
  }
}

module.exports = Login;




// WEBPACK FOOTER //
// ./src/components/Signup.js